import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import Select from '../../../components/Select';
import { ConfirmLimit, ActiveLimit, CooldownLimit, PendingLimit, DeletedLimit } from '../LimitStatus';
import Button from '../../../components/Button';
import Translate from '../../../components/Translate';
import translate from '../../../lib/utils/translate';

var PeriodItemContent = function PeriodItemContent(_ref) {
  var intl = _ref.intl,
      errors = _ref.errors,
      handlePeriodAmount = _ref.handlePeriodAmount,
      activeLimit = _ref.activeLimit,
      canceledLimit = _ref.canceledLimit,
      confirmLimit = _ref.confirmLimit,
      handleConfirm = _ref.handleConfirm,
      handleDecline = _ref.handleDecline,
      handleCancel = _ref.handleCancel,
      displayLimit = _ref.displayLimit,
      type = _ref.type,
      _ref$config = _ref.config,
      config = _ref$config === undefined ? [] : _ref$config,
      title = _ref.title,
      isLoading = _ref.isLoading,
      pendingLimit = _ref.pendingLimit,
      cooldownLimit = _ref.cooldownLimit,
      timeUntilNewLimit = _ref.timeUntilNewLimit,
      timeUntilConfirm = _ref.timeUntilConfirm,
      timeUntilDelete = _ref.timeUntilDelete,
      timespan = _ref.timespan,
      currency = _ref.currency;

  var types = config.map(function (c) {
    return {
      label: translate({ id: c.label }, intl),
      value: c.value
    };
  });

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'div',
      { className: 'limit-container' },
      displayLimit && (type === 'RealityCheck' || type === 'Session') && React.createElement(
        'div',
        { className: 'limit-info-container period' },
        React.createElement(ActiveLimit, { type: type, amount: displayLimit.Amount })
      ),
      !displayLimit && type && type !== 'Block' && type !== 'SelfExclude' && React.createElement(
        'div',
        { className: 'limit-info-container period' },
        React.createElement(Translate, {
          id: 'message.responsiblegaming.no-limit-set',
          defaultMessage: 'No limits yet',
          values: {
            title: React.createElement(Translate, { id: title })
          }
        })
      ),
      React.createElement(Select, {
        className: 'layout-item period',
        options: types,
        onChange: handlePeriodAmount,
        value: displayLimit ? displayLimit.Amount : null,
        name: 'Amount',
        disabled: confirmLimit || cooldownLimit || pendingLimit,
        status: errors.Amount && 'failure',
        statusText: errors.Amount && translate({ id: errors.Amount }, intl)
      }),
      confirmLimit && React.createElement(
        'div',
        null,
        React.createElement(ConfirmLimit, {
          amount: confirmLimit.Amount,
          timespan: confirmLimit.Timespan,
          type: type
        }),
        React.createElement(
          Button,
          {
            className: 'button primary wide',
            type: 'button',
            onClick: function onClick() {
              return handleConfirm(confirmLimit.Id);
            } },
          translate({
            id: 'action.button.confirm-limit',
            defaultMessage: 'Confirm limit'
          }, intl)
        ),
        React.createElement(
          Button,
          {
            className: 'button tertiary wide',
            type: 'button',
            onClick: function onClick() {
              return handleDecline(confirmLimit.Id);
            } },
          translate({
            id: 'action.button.decline-limit',
            defaultMessage: 'Decline limit'
          }, intl)
        )
      ),
      !confirmLimit && !cooldownLimit && !pendingLimit && React.createElement(
        Fragment,
        null,
        React.createElement(
          Button,
          {
            className: 'button primary wide',
            type: 'submit',
            disabled: isLoading,
            isLoading: isLoading },
          translate({
            id: 'action.button.submit',
            defaultMessage: 'Submit'
          }, intl)
        ),
        activeLimit && handleCancel && React.createElement(
          Button,
          {
            type: 'button',
            className: 'button tertiary wide',
            onClick: function onClick() {
              return handleCancel(activeLimit.Id);
            } },
          translate({
            id: 'action.button.delete-limit',
            defaultMessage: 'Delete limit'
          }, intl)
        )
      )
    ),
    pendingLimit && timespan === pendingLimit.Timespan && !confirmLimit && React.createElement(
      'div',
      { className: 'pending-container' },
      React.createElement(PendingLimit, {
        date: timeUntilNewLimit,
        amount: pendingLimit.Amount || '',
        type: type,
        currency: currency
      }),
      React.createElement(
        Button,
        {
          className: 'button tertiary wide',
          type: 'submit',
          disabled: isLoading,
          isLoading: isLoading },
        translate({
          id: 'action.button.undo-limit',
          defaultMessage: 'Reset incoming limit'
        }, intl)
      )
    ),
    cooldownLimit && !confirmLimit && React.createElement(
      'div',
      { className: 'pending-container' },
      cooldownLimit && React.createElement(CooldownLimit, {
        date: timeUntilConfirm,
        amount: cooldownLimit.Amount || '',
        type: type
      }),
      React.createElement(
        Button,
        {
          className: 'button tertiary wide',
          type: 'submit',
          disabled: isLoading,
          isLoading: isLoading },
        translate({
          id: 'action.button.undo-limit',
          defaultMessage: 'Reset incoming limit'
        }, intl)
      )
    ),
    canceledLimit && !activeLimit && !confirmLimit && !cooldownLimit && timeUntilDelete.props.value > 0 && React.createElement(
      'div',
      { className: 'pending-container' },
      React.createElement(DeletedLimit, {
        amount: canceledLimit.Amount || '',
        currency: React.createElement(Translate, { id: 'label.minutes', defaultMessage: 'Minutes' }),
        date: timeUntilDelete,
        timespan: canceledLimit.Timespan
      })
    )
  );
};

export default injectIntl(PeriodItemContent);